module.exports = __webpack_public_path__ + "img/DigitalCitizenship_Icon.4b7e96d9.png";